var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChat01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#64B5F6;}\n\t.st1{fill:#2196F3;}\n\t.st2{fill:#FAFAFA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2733",
    transform: "translate(-1241.348 -276.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1557",
    className: "st0",
    d: "M1273.7,306c1.9-2,3-4.6,3-7.4c-0.1-3.4-1.7-6.6-4.4-8.6c-0.1,7.8-7.4,14.1-16.3,14.1h-6.1 c2.3,3.9,7.1,6.5,12.6,6.5h13.1c0.4,0,0.8-0.3,1-0.7c0.2-0.4,0.1-0.9-0.2-1.2L1273.7,306z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1558",
    className: "st1",
    d: "M1256.1,277.9c-7.8,0-14.2,5.4-14.2,12c0,2.8,1.1,5.4,3,7.4l-2.7,2.7 c-0.4,0.4-0.4,1.1,0,1.5c0.2,0.2,0.5,0.3,0.8,0.3h13.1c7.8,0,14.2-5.4,14.2-12S1263.9,277.9,1256.1,277.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1559",
    className: "st2",
    d: "M1262.6,286.6h-13.1c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1,1.1,1.1h13.1 c0.6,0,1.1-0.5,1.1-1.1C1263.7,287.1,1263.3,286.6,1262.6,286.6C1262.7,286.6,1262.6,286.6,1262.6,286.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1560",
    className: "st2",
    d: "M1258.3,291h-8.7c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h8.7c0.6,0,1.1-0.5,1.1-1.1 C1259.3,291.5,1258.9,291,1258.3,291z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChat01);
export default __webpack_public_path__ + "static/media/ico-chat-01.c9b2289cbdcecc165bd5b20ec2957666.svg";
export { ForwardRef as ReactComponent };